import { $api } from "../generated/client";

export const useShopMembersQuery = (shopId: string) => {
  const query = $api.useQuery("get", "/shops/{shopId}/members", {
    params: { path: { shopId } },
  });
  return query;
};

export const useShopMembersSuspenseQuery = (shopId: string) => {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/members", {
    params: { path: { shopId } },
  });
};
